import { LocalStorageWorker } from './localstorage-worker';
import { setBrowserLocaleCookie } from './set-browser-locale-cookie';
export var setLocale = function (_a) {
    var locale = _a.locale, isFromCookie = _a.isFromCookie;
    if (isFromCookie) {
        setBrowserLocaleCookie(locale);
    }
    else {
        LocalStorageWorker.setItem('locale', locale);
    }
};
